/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Onboardingemailsentat3Inputs */

const en__field_onboardingemailsentat3 = /** @type {(inputs: _Field_Onboardingemailsentat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onboarding email sent at`)
};

/**
* | output |
* | --- |
* | "Onboarding email sent at" |
*
* @param {_Field_Onboardingemailsentat3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const _field_onboardingemailsentat3 = /** @type {((inputs?: _Field_Onboardingemailsentat3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Onboardingemailsentat3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_onboardingemailsentat3(inputs)
});
export { _field_onboardingemailsentat3 as "_field_onboardingEmailSentAt" }